// eslint-disable-next-line prefer-destructuring
const ENABLE_REFERRALFORM_INSURANCESECTION =
  process.env.ENABLE_REFERRALFORM_INSURANCESECTION

export const pageCollection = {
  referrerInformation: 'progress/referrer-information',
  patientBasicInfo: 'progress/basic-information',
  patientInformation: 'progress/patient-information',
  patientGuardian: 'progress/patient-guardian',
  serviceMatch: 'progress/service-matching',
  insurance: 'progress/insurance',
  finalize: 'progress/finalize',
  complete: 'complete',
  patientInfoVerification: 'progress/patient-information/verify',
  insuranceVerification: 'progress/insurance/verify',
  appointment: 'progress/appointment',
  review: 'progress/review',
  consentAgreement: 'progress/consent',

  errorReview: 'progress/review/error',
}

export const referralFormRoutes = ENABLE_REFERRALFORM_INSURANCESECTION
  ? [
      { path: '*' }, // start
      { path: pageCollection.referrerInformation },
      { path: pageCollection.patientInformation },
      { path: pageCollection.serviceMatch },
      { path: pageCollection.insurance },
      { path: pageCollection.finalize },
      { path: pageCollection.complete },
    ]
  : [
      { path: '*' }, // start
      { path: pageCollection.referrerInformation },
      { path: pageCollection.patientInformation },
      { path: pageCollection.serviceMatch },
      { path: pageCollection.complete },
    ]

export type ReferralFormRoutePath = (typeof referralFormRoutes)[number]['path']

export const referralFormBasePath = '/patient-referral'

export const patientOnboardingFormRoutes = [
  { path: '*' }, // start
  { path: pageCollection.patientInformation },
  { path: pageCollection.patientInfoVerification },
  { path: pageCollection.insurance },
  { path: pageCollection.insuranceVerification },
  { path: pageCollection.serviceMatch },
  { path: pageCollection.consentAgreement },
  { path: pageCollection.appointment },
  { path: pageCollection.review },
  { path: pageCollection.complete },
  // extra pages
  { path: pageCollection.errorReview },
]

export const progress = [
  patientOnboardingFormRoutes[1],
  patientOnboardingFormRoutes[3],
  patientOnboardingFormRoutes[5],
  patientOnboardingFormRoutes[6],
  patientOnboardingFormRoutes[7],
  patientOnboardingFormRoutes[8],
] as { path: string }[]

export type PatientOnboardingFormRoutePath =
  (typeof patientOnboardingFormRoutes)[number]['path']

export const patientOnboardingFormBasePath = '/patient-onboarding'

export const getPatientOnboardingStepByPath = (
  path: string,
  isReferral: boolean,
): number => {
  if (isReferral) {
    return referralFormRoutes
      .slice(1, referralFormRoutes.length - 1)
      .findIndex((r) => r.path === path)
  }
  switch (path) {
    case pageCollection.patientInformation:
    case pageCollection.patientInfoVerification:
      return 0
    case pageCollection.insurance:
    case pageCollection.insuranceVerification:
      return 1
    case pageCollection.serviceMatch:
      return 2
    case pageCollection.consentAgreement:
      return 3
    case pageCollection.appointment:
      return 4
    case pageCollection.review:
      return 5
    case pageCollection.errorReview:
      return 5
    default:
      return -1
  }
}

export const selfServiceBasePath = '/self-service'
export type SelfServiceFormRoutePath =
  (typeof selfServiceRoutes)[number]['path']
export const selfServiceRoutes = [
  { path: '*' }, // start
  { path: pageCollection.patientBasicInfo },
  { path: pageCollection.patientInfoVerification },
  { path: pageCollection.patientGuardian },
  { path: pageCollection.patientInformation },
]
